<ng-container *ngIf="TREE_DATA?.length">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl"
    [ngClass]="{'tree-view': isView, 'has-error p-0': hasError()}">

    <mat-tree-node class="has-parent" [ngClass]="'level-' + node.level" [style.display]="
        (isView && !node.is_checked)
        ||
        (searchText && hideLeafNode(node) && !showParentNode(node))
        ? 'none' : 'flex'" *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>

      <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
        (change)="todoLeafItemSelectionToggle(node); selectedItem();">{{node.name}}</mat-checkbox>
    </mat-tree-node>

    <mat-tree-node class="parent" *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding
      [ngClass]="'level-' + node.level" [style.display]="hideParentNode(node) && hideLeafNode(node) ? 'none' : 'flex'"
      [class.active]="treeControl.isExpanded(node)">

      <button mat-icon-button matTreeNodeToggle type="button">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_less' : 'chevron_right'}}
        </mat-icon>
      </button>

      <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
        (change)="todoItemSelectionToggle(node); selectedItem();">
        {{node.name}}
      </mat-checkbox>
    </mat-tree-node>

  </mat-tree>
</ng-container>
<p class="has-error" *ngIf="hasNoSearchResults()">
  {{noMatchingMsg | translate}}
</p>
<p class="has-error" *ngIf="hasError()">{{"messages.minOnePermissionRequired" | translate}}</p>
